import { Typography, TypographyProps } from "@mui/material";

// eslint-disable-next-line import/prefer-default-export
export function ScreenTitle(props: Omit<TypographyProps, "variant">) {
  return <Typography {...props} variant="h1" />;
}
